"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageSimpleTransferLabel = void 0;
const getPackageSimpleTransferLabel = (pkg) => {
    if (pkg.airport_transfer && pkg.course_transfer) {
        return "Airport + Golf";
    }
    else {
        if (pkg.airport_transfer) {
            return "Airport Only";
        }
        else if (pkg.course_transfer) {
            return "Golf Only";
        }
    }
};
exports.getPackageSimpleTransferLabel = getPackageSimpleTransferLabel;
